import React, { useMemo } from "react";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import MOCK_DATA from "./components/MOCK_DATA_2.json";
import { COLUMNS } from "./components/Columns";
import { GlobalFilter } from "./components/GlobalFilter";
//import './components/table.css';
import "./components/filtering.css";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export const FoodsDashboard = () => {
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => MOCK_DATA, []);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Tabla de Alimentos</h4>
          <Button
            as="a"
            to="/workout-statistic"
            className="m-2 bg-primary text-white text-center fs-10 d-block rounded"
            data-toggle="modal"
            data-target="#addMoreTraining"
            // onClick={() => setShowModal(true)}
          >
            + Agregar cliente
          </Button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table {...getTableProps()} className="table dataTable display">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {column.canFilter ? column.render("Filter") : null}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {" "}
                            {cell.render("Cell")}{" "}
                          </td>
                        );
                      })}
                      <td className="h-20">
                        {/* <div className="d-flex">
                          <Button
                            as="a"
                            to="/workout-statistic"
                            className="m-2 bg-info btn-xs text-white text-center d-block rounded"
                            data-toggle="modal"
                            data-target="#addMoreTraining"
                            // onClick={() => setShowModal(true)}
                          >
                            <i className="fas fa-pen"></i>
                          </Button>
                          <Button
                            as="a"
                            to="/workout-statistic"
                            className="m-2 bg-danger btn-xs text-white text-center d-block rounded"
                            data-toggle="modal"
                            data-target="#addMoreTraining"
                            // onClick={() => setShowModal(true)}
                          >
                            <i className="fa fa-trash"></i>
                          </Button>
                        </div> */}
                        <div className="d-flex">
            <Link href="#" className="btn btn-primary shadow btn-xs sharp me-1">
              <i className="fas fa-pen"></i>
            </Link>
            <Link href="#" className="btn btn-danger shadow btn-xs sharp">
              <i className="fa fa-trash"></i>
            </Link>
          </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="d-flex justify-content-between">
              <span>
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>
                {""}
              </span>
              <span className="table-index">
                Go to page :{" "}
                <input
                  type="number"
                  className="ms-2"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                />
              </span>
            </div>
            <div className="text-center mb-3">
              <div className="filter-pagination  mt-3">
                <button
                  className=" previous-button"
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                >
                  {"<<"}
                </button>

                <button
                  className="previous-button"
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                >
                  Previous
                </button>
                <button
                  className="next-button"
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                >
                  Next
                </button>
                <button
                  className=" next-button"
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                >
                  {">>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FoodsDashboard;
